import React, { useEffect, useState, useRef } from "react";
import Filter from "../Assets/Images/filter.svg";
import Search from "../Assets/Images/search.svg";
import { useGlobalContext } from "../Context/GlobalContext";
import Cookies from "js-cookie";

const SearchStaff = ({ setDropdownOpen, dropdownRef, toggleDropdown, isDropdownOpen }) => {
    const {
        baseUrl,
        setStaffs,
        departments,
        updatePagination,
        setIsLoading,
        roles,
    } = useGlobalContext();
    console.log(roles)

    const firstRenderRef = useRef(true); // Track the first render


    const [resetFilter, setResetFilter] = useState(false);
    const [gender, setGender] = useState("All");
    const [staffRole, setStaffRole] = useState("All");
    const [staffDateOfJoining, setStaffDateOfJoining] = useState("");
    const [selectedDepartmentName, setSelectedDepartmentName] = useState("none");
    const [searchStaffName, setSearchStaffName] = useState("");

    const handleSearchStaff = async () => {
        const queryParams = new URLSearchParams();
        if (searchStaffName) queryParams.append("name", searchStaffName);
        if (selectedDepartmentName) {
            queryParams.append(
                "department",
                selectedDepartmentName === "none" ? "" : selectedDepartmentName
            );
        }
        if (staffRole) queryParams.append("role", staffRole === "All" ? "" : staffRole);
        if (gender) queryParams.append("gender", gender === "All" ? "" : gender);
        if (staffDateOfJoining) queryParams.append("date_of_joining", staffDateOfJoining);

        setIsLoading(true);
        try {
            const response = await fetch(`${baseUrl}staff/search?${queryParams}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                }
            });
            if (response.status === 200) {
                const result = await response.json();
                console.log(result);
                setStaffs(result?.data);
                updatePagination(
                    result?.meta?.currentPage,
                    result?.meta?.totalPages,
                    result?.meta?.totalRecords
                );
            } else {
                console.log("Error while fetching staff");
            }
        } catch (error) {
            console.error("Error searching staff:", error);
        } finally {
            setResetFilter(false);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (resetFilter) {
            setSelectedDepartmentName("none");
            setGender("All");
            setStaffRole("All");
            setStaffDateOfJoining("");
            setSearchStaffName("");
        }
    }, [resetFilter]);

    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            if (!firstRenderRef.current) {
                // Skip the first render and trigger the search only after subsequent renders
                handleSearchStaff();
            } else {
                firstRenderRef.current = false; // Mark first render as completed
            }
        }, 800); // Adjusted debounce delay to 800ms

        return () => clearTimeout(debounceTimer); // Cleanup the timer on component unmount or dependency change
    }, [searchStaffName, selectedDepartmentName, gender, staffRole, staffDateOfJoining]);
    
    return (
        <div className="flex lg:flex lg:flex-row flex-col gap-[10px] lg:gap-[20px] w-full">
            <div className="relative searching-input">
                <img src={Search} className="top-3 left-2 absolute" alt="search" />
                <input
                    type="text"
                    className="bg-[#fff] p-[8px] pl-[30px] border rounded-md focus-visible:outline-none w-[100%] lg:w-[225px]"
                    placeholder="Search"
                    value={searchStaffName}
                    onChange={(e) => setSearchStaffName(e.target.value)}
                />
            </div>

            <select
                value={selectedDepartmentName}
                className="bg-[#fff] p-[8px] border rounded-md focus-visible:outline-none w-[100%] lg:w-[240px] h-[42px] text-sm"
                onChange={(e) => setSelectedDepartmentName(e.target.value)}
            >
                <option value="none">Select Department</option>
                {departments?.map((department) => (
                    <option key={department?.id} value={department?.id}>
                        {department?.department_name}
                    </option>
                ))}
            </select>

            <div className="relative flex justify-between gap-5">
                <button
                    className="flex justify-end items-center gap-[10px] whitespace-nowrap cursor-pointer"
                    onClick={toggleDropdown}
                >
                    <img
                        src={Filter}
                        className="bg-[#F4F5F9] p-[10px] rounded-full w-[40px] h-[40px]"
                        alt="filter"
                    />
                    <h2 className="font-normal text-[14px]">More Filters</h2>
                </button>
                <button
                    onClick={() => setResetFilter(true)}
                    className="second-btn"
                >
                    Reset
                </button>

                {isDropdownOpen && (
                    <div
                        ref={dropdownRef}
                        className="lg:left-[0px] z-10 absolute bg-white shadow-lg mt-2 p-[20px] border border-gray-200 rounded-md w-[270px] sm:w-[286px] md:w-[400px] lg:w-[325px] xl:w-[400px]"
                    >
                        <h2 className="border-b">More Filters</h2>
                        <div className="flex items-center gap-[10px] mt-2">
                            <label className="w-[152px] text-[13px] whitespace-nowrap">
                                Staff Role:
                            </label>
                            <select
                                className="bg-[#F4F5F9] p-[8px] border rounded-md focus-visible:outline-none w-full text-sm"
                                value={staffRole}
                                onChange={(e) => setStaffRole(e.target.value)}
                            >
                                <option value="All">All</option>
                                {roles?.map((role) => (
                                    <option key={role?.id} value={role?.id}>
                                        {role?.role_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="flex items-center gap-[10px] mt-2">
                            <label className="w-[152px] text-[13px] whitespace-nowrap">
                                Staff Gender:
                            </label>
                            <select
                                className="bg-[#F4F5F9] p-[8px] border rounded-md focus-visible:outline-none w-full text-sm"
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                            >
                                <option value="All">All</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Others">Others</option>
                            </select>
                        </div>
                        <div className="flex items-center gap-[10px] mt-2">
                            <label className="w-[120px] text-[13px] whitespace-nowrap">
                                Date of Joining:
                            </label>
                            <input
                                value={staffDateOfJoining}
                                onChange={(e) => setStaffDateOfJoining(e.target.value)}
                                type="date"
                                className="bg-[#F4F5F9] p-[8px] border rounded-md focus-visible:outline-none w-full text-sm"
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchStaff;
